import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Barcode from 'react-barcode';
import LeftArrow from '../../assets/icons/arrow-left.svg';
import DownloadIcon from '../../assets/icons/download.svg';
import ScreenLoader from './ScreenLoader';
import ProgressModal from './modals/progress';
import { useLocation } from 'react-router';
import { AuthenticatedGETRequest } from '../../utils';

export const GenerateBarCode = (id) => <Barcode value={id} />;

const StudentCard = () => {
    const { search } = useLocation();
    const [student, setStudent] = useState(null);
    const [URLparams, setURLParams] = useState(null);
    const [progress_model, setProgressModelOpening] = useState(false);

    const getAddress = (address) => address.match(/.{1,50}/g);

    useEffect(() => {
        const params = JSON.parse(
            '{"' +
                decodeURI(search)
                    .replace(/\?/g, '')
                    .replace(/"/g, '\\"')
                    .replace(/&/g, '","')
                    .replace(/=/g, '":"') +
                '"}',
        );
        setURLParams(params);
        const fetchStudent = async (applicantId) => {
            const { data, success, message } = await AuthenticatedGETRequest(
                `students/${applicantId}`,
            );
            if (success) {
                setStudent(data);
            } else {
                console.error('Error fetching data:', message);
            }
        };
        fetchStudent(params.id);
    }, [search]);

    return student ? (
        <div className='flex column alignCenter justifyCenter'>
            <ProgressModal open={progress_model} onClose={() => setProgressModelOpening(false)} />
            <div
                className='pdf_button back_button'
                id='back_button'
                onClick={() =>
                    window.location.replace(`/dashboard/students/detail?id=${URLparams.id}`)
                }
            >
                <img src={LeftArrow} alt='back_icon' width={48} height={48} />
                <h4>واپس جائیں</h4>
            </div>
            <div
                className='pdf_button print_application_button'
                id='print_application_button'
                onClick={() => {
                    window.document.getElementById('back_button').style.display = 'none';
                    window.document.getElementById('print_application_button').style.display =
                        'none';
                    window.print();
                    window.document.getElementById('print_application_button').style.display =
                        'flex';
                    window.document.getElementById('back_button').style.display = 'flex';
                }}
            >
                <img src={DownloadIcon} alt='download_icon' width={48} height={48} />
                <h4>پرنٹ کارڈ</h4>
            </div>

            <main
                className='flex column alignCenter justifyCenter'
                id='A4_page'
                style={{ margin: '1cm 0 0' }}
            >
                <h4 style={{ fontSize: 24 }}>سامنے کی طرف</h4>
                <div className='card_page_size'>
                    <div className='flex column justifyCenter alignStart'>
                        <div className='card_header'>
                            <h4 style={{ fontSize: 18, textTransform: 'uppercase' }}>
                                Jamia Nizamia Rizvia
                            </h4>
                            <p style={{ fontSize: 10, marginTop: 4 }}>
                                Inside Lohari Gate, Androon Lahore. Tel.no: 042-37657314,
                                042-37665772
                            </p>
                        </div>
                        <div
                            className='flex jsutifyBetween alignCenter w-100'
                            style={{ padding: '8px' }}
                        >
                            <img
                                src={student['image_url']}
                                alt='profile banner'
                                height={140}
                                width={140}
                                style={{ borderRadius: 8, objectFit: 'cover', margin: '8px 0' }}
                            />
                            <div
                                className='flex jusifyStart alignCenter'
                                style={{ margin: '4px 0 0 12px' }}
                            >
                                <div className='flex column justifyCenter alignStart'>
                                    <p style={{ fontSize: 14, margin: 0 }}>ID:</p>
                                    <p style={{ fontSize: 14, margin: '8px 0' }}>Name:</p>
                                    <p style={{ fontSize: 14, margin: 0 }}>Cnic:</p>
                                    <p style={{ fontSize: 14, margin: '8px 0' }}>Issue:</p>
                                    <p style={{ fontSize: 14, margin: 0 }}>Expiry:</p>
                                </div>

                                <div
                                    className='flex column justifyCenter alignStart'
                                    style={{ marginLeft: 16 }}
                                >
                                    <p style={{ fontSize: 12, margin: 0, fontWeight: 400 }}>
                                        {student['registration_id']}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: 12,
                                            fontWeight: 400,
                                            margin: '8px 0',
                                            textTransform: 'capitalize',
                                        }}
                                    >
                                        {student['name_for_card']}
                                    </p>

                                    <p style={{ fontSize: 12, fontWeight: 400, margin: 0 }}>
                                        {student['cnic']}
                                    </p>
                                    <p style={{ fontSize: 12, fontWeight: 400, margin: '8px 0' }}>
                                        {moment(student['created_at']).format('DD/MM/yyyy')}
                                    </p>
                                    <p style={{ fontSize: 12, fontWeight: 400, margin: 0 }}>
                                        {moment(student['created_at'])
                                            .add(1, 'years')
                                            .format('DD/MM/yyyy')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <h4 style={{ fontSize: 24 }}>پچھلی طرف</h4>
                <div className='card_page_size'>
                    <div className='flex column justifyCenter alignStart background_side'>
                        <div
                            className='flex column justifyStart alignStart'
                            style={{
                                width: '100%',
                                height: '100%',
                                minHeight: '2.4in',
                                padding: '16px 14px 0px',
                                background: '#ffffff99',
                                borderRadius: 12,
                                position: 'relative',
                            }}
                        >
                            <div
                                className='flex justifyStart alignCenter'
                                style={{
                                    width: '100%',
                                    height: 30,
                                    borderBottom: '2px solid #000',
                                }}
                            >
                                <p
                                    style={{
                                        fontSize: 14,
                                        margin: '4px 0',
                                        width: 280,
                                        textAlign: 'left',
                                    }}
                                >
                                    Department:
                                    <span style={{ fontWeight: 400, fontSize: 12, paddingLeft: 8 }}>
                                        {student['department_for_card']
                                            ? student['department_for_card']
                                            : 'N/A'}
                                    </span>
                                </p>
                                <p
                                    style={{
                                        fontSize: 14,
                                        margin: '4px 0',
                                        width: 220,
                                        textAlign: 'left',
                                    }}
                                >
                                    Class:
                                    <span style={{ fontWeight: 400, fontSize: 12, paddingLeft: 8 }}>
                                        {student['section_for_card']
                                            ? student['section_for_card']
                                            : 'N/A'}
                                    </span>
                                </p>
                            </div>
                            <div
                                className='flex justifyStart alignCenter'
                                style={{
                                    width: '100%',
                                    margin: '12px 0',
                                    height: 30,
                                    borderBottom: '2px solid #000',
                                }}
                            >
                                <p
                                    style={{
                                        fontSize: 14,
                                        margin: '4px 0',
                                        width: 280,
                                        textAlign: 'left',
                                    }}
                                >
                                    Contact #:
                                    <span style={{ fontWeight: 400, fontSize: 12, paddingLeft: 8 }}>
                                        {student['primary_phone_number']
                                            ? student['primary_phone_number']
                                            : 'N/A'}
                                    </span>
                                </p>
                                <p
                                    style={{
                                        fontSize: 14,
                                        margin: '4px 0',
                                        width: 220,
                                        textAlign: 'left',
                                    }}
                                >
                                    Hostilite:
                                    <span style={{ fontWeight: 400, fontSize: 12, paddingLeft: 8 }}>
                                        {student['is_from_hostel_status_for_card'] ? 'Yes' : 'No'}
                                    </span>
                                </p>
                            </div>
                            <div
                                className='flex column justifyStart alignCenter'
                                style={{
                                    width: '100%',
                                }}
                            >
                                {student['address_for_card'] &&
                                    getAddress(student['address_for_card']).map((address, index) =>
                                        getAddress(student['address_for_card']).length === 1 ? (
                                            <div className='flex column w-100'>
                                                <p
                                                    style={{
                                                        fontSize: 14,
                                                        margin: '4px 0',
                                                        textAlign: 'left',
                                                        width: '100%',
                                                        height: 30,
                                                        borderBottom: '2px solid #000',
                                                    }}
                                                >
                                                    {index === 0 ? `Address:` : null}
                                                    <span
                                                        style={{
                                                            fontWeight: 400,
                                                            paddingLeft: 8,
                                                            fontSize: 12,
                                                            textTransform: 'capitalize',
                                                        }}
                                                    >
                                                        {address}
                                                    </span>
                                                </p>
                                                <div
                                                    style={{
                                                        width: '100%',
                                                        height: 30,
                                                        borderBottom: '2px solid #000',
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <p
                                                style={{
                                                    fontSize: 14,
                                                    margin: '4px 0',
                                                    textAlign: 'left',
                                                    width: '100%',
                                                    height: 30,
                                                    borderBottom: '2px solid #000',
                                                }}
                                            >
                                                {index === 0 ? `Address:` : null}
                                                <span
                                                    style={{
                                                        fontWeight: 400,
                                                        fontSize: 12,
                                                        textTransform: 'capitalize',
                                                        paddingLeft: index === 0 ? 8 : 0,
                                                    }}
                                                >
                                                    {address}
                                                </span>
                                            </p>
                                        ),
                                    )}
                            </div>
                            <div className='barcode'>{GenerateBarCode(student['id'])}</div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    ) : (
        <ScreenLoader />
    );
};

export default StudentCard;
